import React from "react";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Box,
} from "@material-ui/core";

export const listWithCategoriesRenderer = (
    values,
    name,
    fieldUpdateHandler,
    mutable,
    defaultValues,
) => {
    let idxList = [];
    let renderValuesEl = [];

    if (values && values?.length > 0) {
        idxList = values.some((elem) => typeof elem === "object")
            ? values.map((value) => value.id)
            : values;
    }

    renderValuesEl =
        defaultValues?.length > 0 &&
        defaultValues.map((defValue) => (
            <Box key={defValue.id}>
                <Box>{defValue.room_features?.length > 0 && defValue.name}</Box>
                {defValue.room_features?.map((feature) => (
                    <FormControlLabel
                        disabled={mutable ? false : true}
                        key={feature.id}
                        checked={idxList.includes(feature.id)}
                        control={
                            <Checkbox
                                name={feature.id?.toString()}
                                color="primary"
                                onChange={(e) =>
                                    handleChange(
                                        name,
                                        e.target.name,
                                        fieldUpdateHandler,
                                        values,
                                        defValue.room_features,
                                    )
                                }
                            />
                        }
                        label={feature.name}
                    />
                ))}
            </Box>
        ));

    return renderValuesEl ? (
        <FormGroup>{renderValuesEl}</FormGroup>
    ) : (
        <Typography>Нет удобств</Typography>
    );
};

// Helper funcs

/**
 * Updates payment methods connected to rate
 *
 * @param {string} fieldName
 * @param {string} pickedIdString
 * @param {function} fieldUpdater
 * @param {Object[]} values
 * @param {Object[]} hotelDefaultValues
 */

const handleChange = (
    fieldName,
    pickedIdString,
    fieldUpdater,
    values,
    hotelDefaultValues,
) => {
    const pickedId = parseInt(pickedIdString);
    let itemsToChange = !values || values.length === 0 ? [] : values;
    const existingIdxSet =
        itemsToChange.length === 0
            ? new Set()
            : new Set(itemsToChange.map((method) => method.id));

    for (const hotelValue of hotelDefaultValues) {
        if (!existingIdxSet.has(pickedId)) {
            if (hotelValue.id === pickedId) {
                itemsToChange.push(hotelValue);
            }
        } else if (existingIdxSet.has(pickedId)) {
            itemsToChange = itemsToChange.filter(
                (method) => method.id !== pickedId,
            );
        }
    }

    fieldUpdater(fieldName, itemsToChange);
};
